import { apiFetch } from "./client.ts";
import type { Job } from "./jobs.ts";

export interface CalendarTechnicianLane {
  user_id: string;
  full_name: string;
  avatar_url: string | null;
  jobs: Job[];
}

export interface CalendarDay {
  date: string; // YYYY-MM-DD
  open_time: string | null; // HH:MM:SS
  close_time: string | null;
  timezone: string;
  lanes: CalendarTechnicianLane[];
  unassigned: Job[];
}

export interface ConflictItem {
  job_id: string;
  job_number: string;
  title: string;
  scheduled_start: string;
  scheduled_end: string;
}

export interface ConflictCheck {
  has_conflict: boolean;
  in_business_hours: boolean;
  conflicts: ConflictItem[];
}

export async function getCalendarDay(params: { date: string; site_id?: string }): Promise<CalendarDay> {
  const usp = new URLSearchParams();
  usp.set("date", params.date);
  if (params.site_id) usp.set("site_id", params.site_id);
  return apiFetch<CalendarDay>(`/calendar?${usp}`);
}

export async function checkConflict(params: {
  technician_id: string;
  start: string;
  end: string;
  exclude_job_id?: string;
  site_id?: string;
}): Promise<ConflictCheck> {
  const usp = new URLSearchParams();
  usp.set("technician_id", params.technician_id);
  usp.set("start", params.start);
  usp.set("end", params.end);
  if (params.exclude_job_id) usp.set("exclude_job_id", params.exclude_job_id);
  if (params.site_id) usp.set("site_id", params.site_id);
  return apiFetch<ConflictCheck>(`/calendar/conflict-check?${usp}`);
}

export interface RescheduleResult extends Job {
  conflicts: ConflictItem[];
  in_business_hours: boolean;
}

export async function rescheduleJob(
  id: string,
  payload: { technician_id?: string; scheduled_start: string; scheduled_end?: string; force?: boolean },
): Promise<RescheduleResult> {
  return apiFetch<RescheduleResult>(`/jobs/${id}/reschedule`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
